<div class="usa-card" [hidden]="!showBody">
  <app-user-pref-body [screenName]="this.screenName" (updateTable)="updateListPrefs($event)"></app-user-pref-body>
</div>

<div class="grid-row grid-gap padding-bottom-1">
  @if (!showBody) {
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <button type="button" class="usa-button" (click)="gotoUserPrefs()">Set data view preferences</button>
    </div>
  }
  @if (showBody) {
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <button type="button" class="usa-button" (click)="closeUserPrefs()">Close data view preferences</button>
    </div>
  }
</div>


<div class="grid-row grid-gap">
  <div class=" padding-bottom-1 grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
    </div>
  </div>
  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <ag-grid-angular class="ag-theme-alpine" [gridOptions]="shipmentReviewGridOptions" [rowData]="shipmentReviewList" [columnDefs]="columnDefs" [suppressDragLeaveHidesColumns]="true">
    </ag-grid-angular>
  </div>
</div>